import React from 'react'
import { useLocation } from '@reach/router'
import PostLink from '../components/post-link'
import Layout from '../components/layout'
import BlogCard from '../components/blogCard'

const SectionPage = ({
  data: {
    site,
    allMarkdownRemark: { edges },
  },
}) => {
  const location = useLocation()
  // Get the tag name
  const section = location.pathname.split('/')[2]
  // Filter posts by tag
  const sectionPosts = edges
  .filter(edge => !!edge.node.frontmatter.date && edge.node.frontmatter.section === section) // You can filter your posts based on some criteria
  .map(edge => <BlogCard key={edge.node.id} post={edge.node} />)
  return(
    <>
    <Layout>
    <h2>{section} &darr;</h2>
      <div className="grids">
        {sectionPosts}
      </div>
      </Layout>
      </>
  )
}
export default SectionPage

export const pageQuery = graphql`
  query sectionPageQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            thumbnail
            tags
            section
          }
        }
      }
    }
  }
`
